const baseUrl = 'https://apii.ordermax.cc'

export default baseUrl
